import { Bundle } from '@ali/visualengine';
import { CnLayoutPagePrototype } from "./cn-layout-page/prototype";
import { CnLayoutCellPrototype } from "./cn-layout-cell/prototype";
import { CnLayoutHeaderPrototype } from "./cn-layout-header/prototype";
import { CnLayoutFooterPrototype } from "./cn-layout-footer/prototype";
import { CnLayoutContentPrototype } from "./cn-layout-content/prototype";
import { CnLayoutSectionPrototype } from "./cn-layout-section/prototype";
import { CnLayoutRowPrototype } from "./cn-layout-row/prototype";
import { CnLayoutColPrototype } from "./cn-layout-col/prototype";
import { CnLayoutAsidePrototype } from "./cn-layout-aside/prototype";
import { CnLayoutBlockPrototype } from "./cn-layout-block/prototype";

// 通过arr控制输出的顺序
var bundle = [CnLayoutPagePrototype, CnLayoutCellPrototype, CnLayoutHeaderPrototype, CnLayoutFooterPrototype, CnLayoutContentPrototype, CnLayoutSectionPrototype, CnLayoutRowPrototype, CnLayoutColPrototype, CnLayoutAsidePrototype, CnLayoutBlockPrototype].map(function (item) {
  return Bundle.createPrototype(item);
});
export default bundle;